import Recorder from '../video/Recorder';
import User from '../data/User';
import { Frame } from '../data/Frame';
import { ModalData } from '../data/ModalData';
import {
  FlyerData,
  PointData,
  TemplateOptions,
  TemplateUI
} from '../data/FlyerData';
import { PlatformType } from 'data/PlatformType';
import { ITextStyle } from 'data/ITextStyle';
import Layer from 'data/Layer';
import { ShapeFrame } from 'data/ShapeFrame';
import Alert from 'data/Alert';
import { History } from 'history';
import { FigmaPaymentStatus } from 'data/Figma';

export enum TemplateEditMode {
  None,
  Simple,
  Advanced
}

export default interface AppState {
  userHasInteractedWithPage: boolean;
  // flowState: FlowState;
  error: any;
  user: User | null;
  isAutoLogging: boolean;
  lastUserUpdate: number; // update every hour
  alerts: Alert[];
  recorder: Recorder | null;
  // recordingBlob: Blob | null;
  // recordingBlobCompressed?: Blob;
  // recordingURL: string | null;
  // recordingWasSmooth: boolean;
  videoThumbnail: File | null;
  history: History;
  // hasDownloadedRecording: boolean;
  tourIndex: number;
  isRenderingPipeline: boolean;
  platform: PlatformType;
  deviceModel?: string;
  isBeatflyerLite: boolean;
  audioWaveSrc?: string;
  selectedFrame: Frame | null;
  selectedMask: Layer | null;
  editedShape: Layer | ShapeFrame | null; // Layer means mask
  proposedEditedShape: PointData[] | null;
  openedModals: ModalData[];
  controllerHasConfirmation: boolean;
  templateUI: TemplateUI[] | null;
  templateOptions: TemplateOptions | null;
  allTemplates?: FlyerData[];
  templateEditMode: TemplateEditMode;
  lastEditedTextStyle?: ITextStyle;
  isCloudRenderer: boolean;
  hideRendererWatermark: boolean;
  detachColorTheme: boolean;
  // hasUnrecordedChanges: boolean;
  figmaPaymentStatus?: FigmaPaymentStatus;
  importDesign: boolean;
}

export const isFigmaPro = (state: AppState): boolean => {
  return (
    state.platform === PlatformType.Figma && state.figmaPaymentStatus === 'PAID'
  );
};



// WEBPACK FOOTER //
// ./src/state/AppState.ts